import { mapActions } from 'vuex'
import md5 from 'md5'

// PC端登录逻辑
export default {
    data() {
        return {
            uInfo: {
                phone: '',
                password: '',
            },
            ruleValidate: {
                phone: [
                    {
                        required: true,
                        message: '账号必填',
                    },
                ],
                password: [
                    {
                        required: true,
                        message: '密码必填',
                    },
                ],
            },
            loading: false,
        }
    },
    computed: {
        // 当前年份
        curYear() {
            return `${new Date().getFullYear()}`
        },
    },
    methods: {
        ...mapActions(['handleLogin']),
        // 提交
        onSubmit() {
            this.$refs.uInfo.validate((valid) => {
                if (valid) {
                    this.handleSubmit({
                        phone: this.uInfo.phone,
                        password: md5(this.uInfo.password),
                    })
                }
            })
        },
        // 登录
        handleSubmit({ phone, password }) {
            this.loading = true

            this.handleLogin({ phone, password })
                .then(() => {
                    // 跳转到首页
                    this.$router.push('/')
                })
                .catch(() => (this.loading = false))
        },
        // 预知官网
        toCompany() {
            window.open('http://www.yuzhi.cn')
        },
    },
}
